import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'goodwill-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Goodwill Nurse Health Coach',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 8004592003,
  email: 'support@goodwillhealth.org',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/goodwill/index.js